import React from "react"
import classnames from "classnames"

import styles from "./styles.css"

const ManagerOnlineInterfaceSkeleton = () => {
  const mainSectionClasses = classnames(
    styles.mainSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )
  const titleClasses = classnames(styles.skeletonText, styles.skeleton)
  const selectClasses = classnames(styles.skeletonSelect, styles.skeleton)
  const hoursBalanceClasses = classnames(
    styles.hoursBalanceText,
    styles.skeleton
  )
  const detailsClasses = classnames(styles.skeletonDetails, styles.skeleton)

  return (
    <div
      className={`Grid-cell u-flex u-flexJustifyBetween ${mainSectionClasses}`}
    >
      <div className="u-flex u-flexCol">
        <div className={titleClasses}></div>
        <div className={selectClasses}></div>
      </div>
      <div className="u-flex u-flexCol">
        <div className={hoursBalanceClasses}></div>
        <div className={detailsClasses}></div>
      </div>
    </div>
  )
}

export default ManagerOnlineInterfaceSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/ManagerOnlineInterfaceSkeleton/index.js